exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroll.voucher-qr-code .btn-ok:disabled{background:#ccc;color:#fff;box-shadow:none}.scroll.voucher-qr-code .mytips{margin-top:.346667rem}.scroll.voucher-qr-code .mytips .mygray{color:#333}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a396f95","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/voucher/VoucherQrCode.vue
// module id = 419
// module chunks = 0